export type RefundStatus = 'approved' | 'denied' | 'pending';
export type RefundRequestReason = 'accident' | 'changedMind' | 'damaged' | 'other' | 'unableToUse';

export interface RequestReason {
  description: string;
  key: string;
}

export const refundRequestReasons: RequestReason[] = [
  {
    description: 'I purchased this by accident.',
    key: 'accident',
  },
  {
    description: "I can no longer / don't want to attend.",
    key: 'unableToUse',
  },
  {
    description: 'I have changed my mind',
    key: 'changedMind',
  },
  {
    description: 'Item is damaged or not as described.',
    key: 'damaged',
  },
  {
    description: 'Other',
    key: 'other',
  },
];

export function getRefundRequestReason(reasonKey: string): string {
  const reason = refundRequestReasons.find(({ key }) => key === reasonKey);
  return reason?.description ?? 'Unknown';
}
